// ViewProductModal.jsx
import { FaAngleLeft, FaAngleRight, FaMinus, FaPlus } from "react-icons/fa";
import "./ViewProductModal.scss";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../../../Components/AppProvider";

function ViewProductModal({
  productId,
  HandleAddToBag,
  setWishToggle,
  wishToggle,
  onToggleLike,
}) {
  const [images, setImages] = useState([]);
  const [product, setProduct] = useState(null);
  const [imageIndex, setImageIndex] = useState(0);
  const navigate = useNavigate();

  const { setHasWishlistCount, customerId } = useAppContext();

  useEffect(() => {
    // Restore quantity from redirectAfterLogin
    const saved = JSON.parse(localStorage.getItem("redirectAfterLogin"));
    if (saved && saved.productId === productId && saved.quantity) {
      setQuantity(saved.quantity);
    }
  }, [productId]);
  useEffect(() => {
    if (productId && customerId) {
      fetch(
        `${process.env.REACT_APP_BASE_URL}api/wishlist/check/${productId}/${customerId}`,
      )
        .then((res) => res.json())
        .then((data) => setIsLiked(data.exists))
        .catch((err) => console.error("Failed to check wishlist:", err));
    }
  }, [productId, customerId]);
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/product/get-product-by-id-with-foreign/${productId}`,
        );
        const data = await res.json();
        if (!data.product) return;
        const prod = data.product;
        setProduct(prod);
        console.log("prod", prod);

        const imageUrls = Array.isArray(prod.PD_ProductPicPath)
          ? prod.PD_ProductPicPath.map((img) => ({
              id: img,
              src: `${process.env.REACT_APP_BASE_URL}Assets/Products/${prod.PD_ID}/${img}`,
              name: img,
            }))
          : [];
        setImages(imageUrls);
      } catch (err) {
        console.error("Failed to fetch product", err);
      }
    };
    fetchProduct();
  }, [productId]);

  // ---- SCROLL LOGIC ----
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const scrollAmount = 200;
  const [isAdding, setIsAdding] = useState(false);

  const handleAddToBagClick = async (productId, quantity) => {
    setIsAdding(true); // disable button immediately

    try {
      await HandleAddToBag(productId, quantity);
      // Optionally show success toast or message
    } catch (err) {
      console.error(err);
    } finally {
      setIsAdding(false); // re-enable button if needed
    }
  };
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setShowLeft(scrollLeft > 0);
    setShowRight(scrollLeft + clientWidth < scrollWidth);
  };

  const scrollLeftClick = () => {
    scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  };

  const scrollRightClick = () => {
    scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  useEffect(() => {
    handleScroll();
  }, [images]);

  // ---- QUANTITY ----
  const [quantity, setQuantity] = useState(1);
  const [isLiked, setIsLiked] = useState(false);
  const toggleLike = async () => {
    try {
      // ✅ Check login
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
        {
          credentials: "include",
        },
      );
      const data = await res.json();

      if (!data?.CP_ID) {
        const confirmLogin = window.confirm(
          "You need to log in to add this product to your wishlist. Log in now?",
        );
        if (confirmLogin) navigate("/login");
        return;
      }

      const customerId = data.CP_ID;
      const command = isLiked ? "remove" : "add";

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/wishlist/add-drop-wish/${productId}/${customerId}/${command}`,
        {
          method: "POST",
          credentials: "include",
        },
      );

      const result = await response.json();

      if (response.ok) {
        setIsLiked(!isLiked);
        setHasWishlistCount(true);
        setWishToggle((prev) => !prev);
        //console.log(result.message);
      } else {
        alert(result.error || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
    }
  };

  // ---- DATE FORMAT ----
  const formatDate = (val) => {
    if (!val) return "";
    try {
      return new Date(val).toISOString().slice(0, 10);
    } catch {
      return val;
    }
  };

  if (!product) {
    return <div className="vpm-container">Loading...</div>;
  }

  if (!product) return <div className="vpm-container">Loading...</div>;

  const isProductAvailable = (
    PD_ProductType,
    PD_Stock,
    PD_Preorderdeadline,
  ) => {
    if (PD_ProductType === "onhand") {
      return PD_Stock > 0 ? true : false;
    } else if (PD_ProductType === "preorder") {
      return new Date(PD_Preorderdeadline) >= new Date() ? true : false;
    }
  };
  return (
    <div className="vpm-container">
      {/* PRODUCT IMAGES */}
      <div className="vpm-prod-pic-container">
        <div className="vmp-preview-pic-wrapper">
          <button
            className={`prod-wishlist-icon ${isLiked ? "is-active" : ""}`}
            onClick={() => {
              onToggleLike(productId);

              setIsLiked(!isLiked);
            }}
          >
            <svg width="18" height="16" viewBox="0 0 18 16">
              <path
                d="M9.01163699,14.9053769 C8.72930024,14.7740736 8.41492611,14.6176996 8.07646224,14.4366167 C7.06926649,13.897753 6.06198912,13.2561336 5.12636931,12.5170512 C2.52930452,10.4655288 1.00308384,8.09476443 1.00000218,5.44184117 C0.997549066,2.99198843 2.92175104,1.01242822 5.28303025,1.01000225 C6.41066623,1.00972036 7.49184369,1.4629765 8.28270844,2.2678673 L8.99827421,2.9961237 L9.71152148,2.26559643 C10.4995294,1.45849728 11.5791258,1.0023831 12.7071151,1.00000055 L12.7060299,1.00000225 C15.0693815,0.997574983 16.9967334,2.97018759 17.0000037,5.421337 C17.0038592,8.07662382 15.4809572,10.4530151 12.8850542,12.5121483 C11.9520963,13.2521931 10.9477036,13.8951276 9.94340074,14.4354976 C9.60619585,14.6169323 9.29297309,14.7736855 9.01163699,14.9053769 Z"
                strokeWidth="1"
              />
            </svg>
          </button>

          <button
            className="prev-pic-left"
            onClick={() => {
              if (imageIndex > 0) {
                setImageIndex(imageIndex - 1);
              } else {
                setImageIndex(images.length - 1); // wrap to last image
              }
            }}
          >
            <FaAngleLeft />
          </button>

          <button
            className="prev-pic-right"
            onClick={() => {
              if (imageIndex < images.length - 1) {
                setImageIndex(imageIndex + 1);
              } else {
                setImageIndex(0); // wrap back to first image
              }
            }}
          >
            <FaAngleRight />
          </button>

          <img
            src={images[imageIndex]?.src || "https://via.placeholder.com/300"}
            alt={product.PD_Name}
          />
        </div>

        <div className="vmp-pagi-pic-wrapper">
          {showLeft && (
            <button className="pagi-pic-left" onClick={scrollLeftClick}>
              <FaAngleLeft />
            </button>
          )}

          <div
            className="vmp-pagi-pic-scroll"
            ref={scrollRef}
            onScroll={handleScroll}
          >
            {images.map((img, index) => (
              <img
                className={imageIndex != index ? "" : "imgActive"}
                key={index}
                onClick={() => {
                  setImageIndex(index);
                }}
                src={img.src}
                alt={`Preview ${index}`}
                onError={(e) =>
                  (e.target.src = "https://via.placeholder.com/150")
                }
              />
            ))}
          </div>

          {showRight && (
            <button className="pagi-pic-right" onClick={scrollRightClick}>
              <FaAngleRight />
            </button>
          )}
        </div>
      </div>

      {/* PRODUCT DETAILS */}
      <div className="vpm-prod-details-container">
        <div
          className={`vpm-prod-type-wrapper ${
            isProductAvailable(
              product.PD_ProductType,
              product.PD_Stock,
              product.PD_Preorderdeadline,
            ) === false
              ? "notAvailable-wrapper"
              : ""
          }`}
        >
          <span
            style={{
              fontSize:
                product.PD_ProductType === "onhand"
                  ? ""
                  : new Date(product.PD_Preorderdeadline) >= new Date()
                    ? ""
                    : "15px",
            }}
          >
            {product.PD_ProductType === "onhand"
              ? product.PD_Stock > 0
                ? `IN STOCK (${product.PD_Stock})`
                : "OUT OF STOCK"
              : new Date(product.PD_Preorderdeadline) >= new Date()
                ? "PRE ORDER"
                : "PRE ORDER ENDED"}
          </span>
        </div>
        <div className="vpm-prod-name-wrapper">{product.PD_Name}</div>
        <div className="vpm-prod-details-wrapper">
          <table>
            <tbody>
              <tr>
                <th>MANUFACTURER:</th>
                <td>{product.PM_Name}</td>
              </tr>
              <tr>
                <th>SERIES:</th>
                <td>{product.AS_Name}</td>
              </tr>

              {product.PD_ProductType === "onhand" ? (
                <>
                  <tr>
                    <th>PRICE:</th>
                    <td>PHP {product.PD_OriginalPrice}</td>
                  </tr>
                  <tr>
                    {isProductAvailable(
                      product.PD_ProductType,
                      product.PD_Stock,
                      product.PD_Preorderdeadline,
                    ) === true ? (
                      <>
                        <th>SALE PRICE:</th>
                        <td>PHP {product.PD_SalePrice}</td>
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                  <tr>
                    <th>DOWNPAYMENT:</th>
                    <td>PHP {product.PD_DownPayment}</td>
                  </tr>
                </>
              ) : (
                <>
                  <tr>
                    <th>PRICE:</th>
                    <td>PHP {product.PD_OriginalPrice}</td>
                  </tr>
                  <tr>
                    <th>DOWNPAYMENT:</th>
                    <td>PHP {product.PD_DownPayment}</td>
                  </tr>
                  <tr>
                    <th>DEADLINE:</th>
                    <td>
                      {" "}
                      {isProductAvailable(
                        product.PD_ProductType,
                        product.PD_Stock,
                        product.PD_Preorderdeadline,
                      ) === true
                        ? formatDate(product.PD_Preorderdeadline)
                        : `${formatDate(product.PD_Preorderdeadline)} (ENDED)`}
                    </td>
                  </tr>
                  <tr>
                    <th>JAPAN ESTIMATED RELEASE DATE:</th>
                    <td>{product.PD_JapanEstmated}</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>

        {/* QUANTITY */}
        {isProductAvailable(
          product.PD_ProductType,
          product.PD_Stock,
          product.PD_Preorderdeadline,
        ) && (
          <div className="vpm-prod-quantity-wrapper">
            <table>
              <tbody>
                <tr>
                  <th>QUANTITY:</th>
                  <td>
                    <input
                      type="text"
                      value={quantity}
                      onChange={(e) => {
                        const onlyDigits = Number(
                          e.target.value.replace(/\D/g, "").slice(0, 11),
                        );
                        if (product.PD_ProductType === "onhand") {
                          if (product.PD_Stock < onlyDigits)
                            setQuantity(product.PD_Stock);
                          else setQuantity(onlyDigits || 1);
                        } else setQuantity(onlyDigits || 1);
                      }}
                    />
                    <button
                      className="minus"
                      onClick={() => quantity > 1 && setQuantity(quantity - 1)}
                    >
                      <FaMinus />
                    </button>
                    <button
                      className="plus"
                      onClick={() => {
                        if (product.PD_ProductType === "onhand") {
                          if (product.PD_Stock > quantity)
                            setQuantity(quantity + 1);
                        } else setQuantity(quantity + 1);
                      }}
                    >
                      <FaPlus />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {/* ORDER GUIDE */}
        <div className="vpm-prod-guide-wrapper">
          {product.PD_ProductType === "preorder" ? (
            <>
              <p>
                **Please be aware that we cannot process orders past the PO
                deadline, as stated by manufacturer/distributor**
              </p>
              <p>
                {" "}
                **PH release is 1-2 months after Japan release. Please be
                mindful that the ETA is based on manufacturer/distributor
                estimates and can CHANGE.**
              </p>
            </>
          ) : (
            ""
          )}
          <p>
            **BY PLACING AN ORDER, YOU ARE AGREEING TO OUR ORDER GUIDELINES.**
          </p>
          <p>
            You may visit our order guidelines <a href="#">here</a>.
          </p>
        </div>
        {/* ADD TO BAG */}
        {isProductAvailable(
          product.PD_ProductType,
          product.PD_Stock,
          product.PD_Preorderdeadline,
        ) && (
          <div className="vmp-prod-buttons-wrapper">
            <button
              className="add-to-bag"
              onClick={() => handleAddToBagClick(product.PD_ID, quantity)}
              disabled={isAdding} // disables button while adding
            >
              {isAdding ? "ADDING..." : "ADD TO BAG"}
            </button>
            {/*<button className="buy-now">BUY NOW</button> */}
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewProductModal;
